import { format, validate } from 'rut.js'
import moment from 'moment'
import { valMin, valMax } from './validation'

export function formatSeconds(seconds = 0) {
  return seconds > 3600
    ? new Date(seconds * 1000).toISOString().substr(11, 8)
    : new Date(seconds * 1000).toISOString().substr(14, 5)
}

export function capitalizeFirstLetter(word) {
  return word.replace(/\w/, l => l.toUpperCase())
}

/**
 *
 * Formatter string to rut
 * @export
 * @param {*} rut
 * @returns Rut
 */
export function formatRut(rut) {
  if (rut.length) {
    return format(rut)
  }
  return rut
}

/**
 *
 * Check if given rut is valid
 * @export
 * @param {*} rut
 * @param {*} excepctionalRuts
 * @returns boolean
 */
export function isRutValid(rut, excepctionalRuts) {
  // exceptionalRuts vienen por mientras como parametro "mockeados"
  // Habrá un endpoint con un listado de ruts excepcionales más adelante
  if (excepctionalRuts.includes(rut)) {
    return true
  }

  return validate(rut) && rut.length > 7 && rut.length < 10
}

/**
 * Normalize String
 *
 * @export
 * @param {*} rawText
 * @returns string
 */
export function normalizeString(rawText) {
  return rawText.normalize(`NFD`).replace(/[\u0300-\u036f]/g, ``)
}

/**
 * Truncate String
 *
 * @export
 * @param {*} text
 * @param {number} [limit=50]
 * @returns Object
 */
export function truncateText(text, limit = 50) {
  let shortText = text
  if (text.length > limit) {
    shortText = `${text.substring(0, limit)}...`
  }
  return {
    shortText,
    text,
  }
}

const regexOptions = {
  phone: {
    regex: /^(\d{1})(\d{4})(\d{4})$/g,
    param: `+56 ($1)-$2-$3`,
  },
  email: {
    // eslint-disable-next-line
    regex: /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/m,
  },
  url: {
    // eslint-disable-next-line
    regex: /([--:\w?@%&+~#=]*\.[a-z]{2,4}\/{0,2})((?:[?&](?:\w+)=(?:\w+))+|[--:\w?@%&+~#=]+)?/g,
  },
}

/**
 * Applies a given option regex test to string
 *
 * @param {*} value
 * @param {*} type
 * @returns boolean
 */
export const regexValidator = (value, type) => {
  const { regex } = regexOptions[type]
  const validator = new RegExp(regex)
  return validator.test(value)
}

/**
 * Replace string by given formatter
 *
 * @export
 * @param {*} value
 * @param {*} type
 * @returns
 */
export function regexFormatter(value, type) {
  const { regex, param = null } = regexOptions[type]
  if (param) {
    return value.toString().replace(regex, param)
  }
  return value
}
const setError = (languageKey, error) => {
  if (languageKey) {
    return {
      [languageKey]: error,
    }
  }
  return error
}

/**
 * check if value is inside range and if is required
 *
 * @export
 * @param {*} { field, value, languageKey = null }
 * @returns
 */
export function checkValueInsideRange({ field, value, languageKey = null }) {
  const {
    rules: { min, max, required = false },
    type = ``,
    multiLanguage,
  } = field
  const fildType = type.toLowerCase()
  let inputProps = { error: false, isValid: true }
  if (fildType === `text` || fildType === `textarea` || fildType === `number`) {
    const valueToCheck = languageKey && multiLanguage ? value[languageKey] : value
    if (min && valMin(valueToCheck, min)) {
      inputProps = {
        error: setError(languageKey, `Debe tener mínimo ${min} caracteres`),
        isValid: false,
      }
    }
    if (max && valMax(valueToCheck, max)) {
      inputProps = {
        error: setError(languageKey, `Debe tener máximo ${max} caracteres`),
        isValid: false,
      }
    }
    if (required && !valueToCheck) {
      inputProps = {
        error: setError(languageKey, `Este campo es obligatorio`),
        isValid: false,
      }
    }
  }
  // inputs sin validaciones
  // check, month, date, image, file, chips, group
  return inputProps
}

/**
 * Validate form
 *
 * @export
 * @param {*} { event, field }
 * @returns
 */
export function formatAndValidate({ event, field }) {
  const {
    rules: { min, max, format = false },
  } = field
  let { value, props = undefined, languageKey = null, ...eventRest } = event
  if (min || max) {
    props = {
      ...props,
      ...checkValueInsideRange({ field, value, languageKey }),
    }
  }
  if (format && value && !regexValidator(value, format)) {
    props.error = !props.error ? setError(languageKey, `El formato es inválido`) : props.error
  }
  return { value, props, ...eventRest }
}

/**
 * Date and time to format: DD/MM/YY | H:m:s
 *
 * @param value string timestamp
 * @returns string
 */
export function formatDateAndTimeShort(value) {
  return moment(value).format(`DD/MM/YY | H:m:s`)
}

export const urlBaseFile = process.env.REACT_APP_API_BASE_FILE || `http://localhost:4000/files/`

export const chunk = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size),
  )

/**
 * Return phone to numeric value to be editable
 *
 * @export
 * @param {*} phone
 * @returns
 */
export function unformatPhone(phone) {
  return Number(phone.replace(/\D/g, ``).slice(2))
}
